import { useMutation, useQuery } from '@zg-rentals/react-query5';
import type { MultiPaymentSummary } from '../components/modals/MultiInvoicePayModal';
import type {
  AdproductsBillingPortalAccountContactDto,
  AdproductsBillingPortalAccountContactsDto,
} from '@zg-rentals/ts-adproducts-client';
import {
  AdproductsUserBillingInvoicePaymentApiHandler_addAccountContact,
  AdproductsUserBillingInvoicePaymentApiHandler_deleteAccountContact,
  AdproductsUserBillingInvoicePaymentApiHandler_getAccountContacts,
  AdproductsUserBillingInvoicePaymentApiHandler_makeMultiPaymentV2,
} from '@zg-rentals/ts-adproducts-client';

const useAccountContacts = (accountNumber: string) => {
  const queryFn = () => AdproductsUserBillingInvoicePaymentApiHandler_getAccountContacts({ accountNumber });
  const queryHook = useQuery<AdproductsBillingPortalAccountContactsDto>({
    queryKey: ['useAccountContacts', accountNumber],
    queryFn,
    enabled: !!accountNumber,
  });
  return queryHook;
};

const useCreateAccountContact = (accountNumber: string, emailToAdd: string) => {
  const mutationFn = () =>
    AdproductsUserBillingInvoicePaymentApiHandler_addAccountContact({
      accountNumber,
      emailToAdd,
    });
  return useMutation({ mutationFn });
};

const useCreateMultiPayment = (multiPayment: MultiPaymentSummary) => {
  const mutationFn = () => AdproductsUserBillingInvoicePaymentApiHandler_makeMultiPaymentV2(multiPayment);
  return useMutation({ mutationFn });
};

const useDeleteAccountContact = (accountNumber: string, contactToRemove: AdproductsBillingPortalAccountContactDto) => {
  const mutationFn = () =>
    AdproductsUserBillingInvoicePaymentApiHandler_deleteAccountContact({
      accountNumber,
      emailToRemove: contactToRemove.workEmail,
      contactId: contactToRemove.id,
    });
  return useMutation({ mutationFn });
};

export { useAccountContacts, useCreateAccountContact, useDeleteAccountContact, useCreateMultiPayment };
